// extracted by mini-css-extract-plugin
export default {"element":"style_element__U6JN7"};